import axios from "axios"
import { API } from "../../../api/api"

export const getPerson = async (name: string) =>
    axios.get(`${API.url}/people?filters[name][$eq]=${name}&populate=*`).then((res) => res?.data?.data[0]?.attributes)
